module.exports = __webpack_public_path__ + "Icono_PQXMenu_126px.png";